import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import * as Sentry from "@sentry/angular-ivy";

import { AppModule } from './app/app.module';
import { environment } from '../../environments/environment';

if (environment.sentry?.dsn?.admin && environment.sentry?.active === true) {
  Sentry.init({
    dsn: environment.sentry.dsn.admin,
    environment: environment.sentry?.stage || 'undefined',
    release: environment.version
  });
}

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
